(function($){
  $(function() {

    var items = $('.js--block-technique');

    if ( items[0] ) {

      items.click(function() {
        $('html, body').animate({
            scrollTop: $(".produit-technique").offset().top - 120
        }, 1500);
      });
      
    }

  });

})(jQuery);